exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card {\n  padding: 25px;\n}\n\n@media screen and (min-width: 0px) and (max-width: 1087px) {\n  .container.minutes-container {\n    margin-left: 5%;\n    margin-right: 5%;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/minutes/minutes.component.css
// module id = ../../../../../src/app/minutes/minutes.component.css
// module chunks = main